import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, X, Clock } from "lucide-react";
import ListingCard from "./ListingCard";
import { recentlyViewedUtils } from "@/utils/recentlyViewed";

const RecentlyViewed = () => {
  const [listings, setListings] = useState([]);

  useEffect(() => {
    const items = recentlyViewedUtils.getAll();
    setListings(items);
  }, []);

  const handleClear = () => {
    recentlyViewedUtils.clear();
    setListings([]);
  };

  if (listings.length === 0) return null;

  return (
    <section className="py-16 px-6 md:px-12 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <Clock className="w-5 h-5 text-[#D4AF37]" />
            <h2 className="text-2xl text-[#EDEDED]">Recently Viewed</h2>
          </div>
          <button 
            onClick={handleClear}
            className="text-sm text-[#71717A] hover:text-[#A1A1AA] flex items-center gap-1 transition-colors"
          >
            Clear <X className="w-4 h-4" />
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {listings.slice(0, 4).map((listing) => (
            <ListingCard key={listing.listing_id} listing={listing} compact />
          ))}
        </div>

        {listings.length > 4 && (
          <div className="mt-6 text-center">
            <span className="text-sm text-[#71717A]">
              +{listings.length - 4} more recently viewed
            </span>
          </div>
        )}
      </div>
    </section>
  );
};

export default RecentlyViewed;
